import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getFieldsByType, getControlIsRenderable } from 'utilities'
import { DumbField, getValidityClass } from '../Field';
import {TextInput, Select, Checkbox} from './Form';
import { stateOptions, getCountryOptions, filteredStateOptions } from '../selectOptions';
import Portal from 'components/Portal/Portal'
import { Modal } from '../../Modal/Modal'
import AddressSelector from './AddressSelector'
import ReactTooltip from 'react-tooltip'
import DocumentCloneIcon from '@tecuity/sos-icons/react/document-clone'
import { VALIDATE } from 'requests'
import { MASK } from '../validate'

export class AddressBlock extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false,
      isBypassAcknowledged: props.value.MAIL_ADDR_BYPASS_YN === "Y"
    }
  }
  componentDidMount = () => {
    if (this.props.isFirst) {
      this.focus()
    }
  }
  setFieldValue = (value, e) => {
    var val = { ...this.props.value }
    val[e.target.name] = value
    this.props.onChange(val, { target: { name: this.props.name, value: val } })
  }
  handleFieldBlur = () => {
    // this.props.onBlur(this.props.value)
  }
  toggleAddressSelect = () => {
    this.setState((state) => ({ modalOpen: !state.modalOpen }))
  }
  copyAddress = (selectedAddress) => {
    this.modal.closeModal()
    let newAddress = { ...selectedAddress }
    if (this.props.disableState) {
      newAddress = { ...newAddress, STATE: this.props.defaultState }
    }
    this.props.onChange(newAddress, {})
  }
  focus = () => {
    this.addr1.focus()
  }
  handleStateBlur = () => {
    if (
      this.props.autoPopulateFromAMS &&
      this.props.value.STATE &&
      this.props.value.CITY &&
      !this.props.value.POSTAL_CODE
    ) {
      this.populateAddressFromAMS()
    }
  }
  handleZipBlur = () => {
    if (
      this.props.autoPopulateFromAMS &&
      this.props.value.POSTAL_CODE &&
      (!this.props.value.STATE || !this.props.value.CITY)
    ) {
      this.populateAddressFromAMS()
    }
  }
  populateAddressFromAMS = () => {
    VALIDATE('address', this.props.value, (data) => {
      const corrected = data.payload.corrected || {}
      let newAddress = this.props.value
      let update = false
      if (
        !this.props.value.STATE &&
        this.props.value.STATE !== corrected.STATE &&
        !this.props.disableState
      ) {
        newAddress = { ...newAddress, STATE: corrected.STATE }
        update = true
      }
      if (!this.props.value.CITY && this.props.value.CITY !== corrected.CITY) {
        newAddress = { ...newAddress, CITY: corrected.CITY }
        update = true
      }
      if (this.props.value.POSTAL_CODE !== corrected.POSTAL_CODE && !this.props.value.POSTAL_CODE) {
        newAddress = { ...newAddress, POSTAL_CODE: corrected.POSTAL_CODE }
        update = true
      }
      if (update) {
        this.props.onChange(newAddress)
      }
    })
  }
  setBypassChecked = (checked) => {
    this.setState({ isBypassAcknowledged: checked });
    const { value, onChange, name } = this.props;
    const updatedValue = { ...value, MAIL_ADDR_BYPASS_YN: checked ? 'Y' : 'N' };
    onChange(updatedValue, { target: { name, value: updatedValue } });
    this.props.onChange(updatedValue, { target: { name, value: updatedValue } });
  }
  
  render() {
    const {
      fieldId,
      address1Label,
      required,
      value,
      isValid,
      disableCountry,
      hideAttention,
      showCounty,
      showCountry,
      showCityStateZip,
      showAddress3 = true,
      disableState,
      disabled,
      hasAddresses,
      allowSelection,
      singleColSize,
      triColSizes = {},
      excludeCurrentState,
      classNames = {},
      defaultState,
      bypassMessage,
      primarybypassMessage,
      mailbypassMessage
    } = this.props
    const isValidClass = getValidityClass(isValid)

    const valueIsNotEmptyOrNull = (value) =>
        (value !== '' && value !== null && value !== undefined && typeof value !== 'object') ||
        value === 0 ||
        value === '0'

    const getTrimmedValue = (value = '') => (!value ? '' : value.trim())

    if (value.STATE == '' && defaultState !== '' && value.COUNTRY == '') {
      value.COUNTRY = 'United States'
    }
    const isForeign =
      value.COUNTRY.toLowerCase() !== 'united states' && value.COUNTRY.toLowerCase() !== 'usa'

    if (value.COUNTRY.toLowerCase() === 'united states') {
      value.COUNTRY = 'United States'
    }
    const label = this.props.label || 'Address'
    const showCityStateZipOnForeignAddress = process.env.USE_CITY_STATE_ON_FOREIGN_ADDRESS
    const showAltForeignAddressLabel = process.env.USE_ALTERNATIVE_FOREIGN_ADDRESS_LABELS
    const countries = getCountryOptions()
    if (!countries.some((country) => country.value === value.COUNTRY)) {
      value.COUNTRY = ''
    }

    if (
      (value.STATE === '' || value.STATE === null) &&
      (defaultState !== '' || defaultState !== null)
    ) {
      value.STATE = defaultState
    }

    const SHOW_ALT_ADDR3_LABEL = process.env.SHOW_ALT_ADDR3_LABEL
    const ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION = process.env.ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION

    const stdBypass = ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION && this.props.businessRules
        ? (this.props.businessRules.find(rule => rule.fn === "addressIsValid")
            ? this.props.businessRules.find(rule => rule.fn === "addressIsValid").props.allowAddressValidationBypass
            : false) 
        : false

    const RegisteredAgentMailBypass = ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION && this.props.businessRules
        ? (this.props.businessRules.find(rule => rule.fn === "registeredAgentAddressIsValid")
            ? this.props.businessRules.find(rule => rule.fn === "registeredAgentAddressIsValid").props.allowAgentAddressMailValidationBypass
            : false)
        : false
    const RegisteredAgentPrimaryBypass = ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION && this.props.businessRules
        ? (this.props.businessRules.find(rule => rule.fn === "registeredAgentAddressIsValid")
            ? this.props.businessRules.find(rule => rule.fn === "registeredAgentAddressIsValid").props.allowAgentAddressPrimaryValidationBypass
            : false)
        : false
    
    const ShowAddressValidationBypass = ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION &&
        (
            valueIsNotEmptyOrNull(getTrimmedValue(value.ADDR1)) &&
            valueIsNotEmptyOrNull(getTrimmedValue(value.CITY)) &&
            valueIsNotEmptyOrNull(getTrimmedValue(value.STATE)) &&
            valueIsNotEmptyOrNull(getTrimmedValue(value.POSTAL_CODE))
        )
        && (value.MAIL_ADDR_BYPASS_YN === 'Y' || 
            ( 
                isValid === false 
                && stdBypass
            ) ||
            (
                isValid === false
                && RegisteredAgentPrimaryBypass
                && this.props.fieldId
                && this.props.fieldId.indexOf('_PRIMARY') !== -1
                && (this.props.errorMessage && this.props.errorMessage.some(message => message.toLowerCase().includes("street")))
            ) ||
            (
                isValid === false
                && RegisteredAgentMailBypass
                && this.props.fieldId
                && this.props.fieldId.indexOf('_MAIL') !== -1
                && (this.props.errorMessage && this.props.errorMessage.some(message => message.toLowerCase().includes("mailing")))
            )
        )
    
    const getBypassMessage = ALLOW_ADDRESS_VALIDATION_BYPASS_OPTION && this.props.fieldId
        ? this.props.fieldId.indexOf('_PRIMARY') !== -1
            ? primarybypassMessage || "I understand that my street address has failed validation. I certify that my address is entered correctly and wish to bypass validation."
            : this.props.fieldId.indexOf('_MAIL') !== -1
              ? mailbypassMessage || "I understand that my mailing address has failed validation. I certify that my address is entered correctly and wish to bypass validation."
              : bypassMessage || "I understand that my mailing address has failed validation. I certify that my address is entered correctly and wish to bypass validation."
        : null
    
    return (
      <div className="address-block">
        <div className="row">
          <div
            className={`${singleColSize ? singleColSize : 'col-sm-9 col-md-8 col-lg-7'} flex-col`}
          >
            <DumbField
              className="auto-width"
              type="text"
              required={required}
              parentType="addressBlock"
              label={
                address1Label
                  ? address1Label
                  : isForeign
                  ? showAltForeignAddressLabel
                    ? 'Address 1 (house/building number and street name)'
                    : 'Address 1'
                  : 'Address'
              }
              fieldId={`address1-${fieldId}`}
            >
              <div className="row-wrapper">
                <TextInput
                  fieldId={`address1-${fieldId}`}
                  onChange={this.setFieldValue}
                  onBlur={this.handleFieldBlur}
                  autoComplete="address-line1"
                  name="ADDR1"
                  value={value.ADDR1}
                  disabled={disabled}
                  required={true}
                  validityClass={isValidClass}
                  isValid={isValid}
                  ref={(addr1) => {
                    this.addr1 = addr1
                  }}
                  ariaLabel={`${label}: Address Line 1`}
                />
                {allowSelection !== false && (
                  <button
                    type="button"
                    className="btn btn-raised btn-primary copy-button"
                    disabled={!hasAddresses || disabled}
                    onClick={this.toggleAddressSelect}
                    data-tip="Copy from"
                    data-for={`copy-${fieldId}`}
                    aria-label="Copy address from"
                  >
                    <DocumentCloneIcon />
                  </button>
                )}
                <ReactTooltip effect="solid" place="top" id={`copy-${fieldId}`} />
              </div>
            </DumbField>
            <Portal isOpened={this.state.modalOpen}>
              <Modal
                title="Select an Address"
                closeModal={this.toggleAddressSelect}
                modalSize="small"
                closeButton
                autoHeight
                ref={(modal) => {
                  this.modal = modal
                }}
              >
                <AddressSelector onSelect={this.copyAddress} fieldId={fieldId} />
              </Modal>
            </Portal>
          </div>
        </div>
        <div className="row">
          <div className={`${singleColSize ? singleColSize : 'col-sm-9 col-md-8 col-lg-7'}`}>
            <DumbField
              type="text"
              required={false}
              parentType="addressBlock"
              label={
                isForeign
                  ? showAltForeignAddressLabel
                    ? 'Address 2 (city, state/province, postal code)'
                    : 'Address 2'
                  : 'STE/APT/FL'
              }
              fieldId={`address2-${fieldId}`}
            >
              <TextInput
                onChange={this.setFieldValue}
                onBlur={this.handleFieldBlur}
                autoComplete="address-line2"
                name="ADDR2"
                value={value.ADDR2}
                disabled={disabled}
                required={false}
                width="100%"
                validityClass={isValidClass}
                isValid={isValid}
                fieldId={`address2-${fieldId}`}
                ariaLabel={`${label}: ${isForeign ? 'Address line 2' : 'STE/APT/FL'}`}
              />
            </DumbField>
          </div>
        </div>
        {showAddress3 && !hideAttention && (
          <div className="row">
            <div className={`${singleColSize ? singleColSize : 'col-sm-9 col-md-8 col-lg-7'}`}>
              <DumbField
                type="text"
                required={false}
                parentType="addressBlock"
                label={
                  isForeign
                    ? showAltForeignAddressLabel
                      ? 'Address 3 (attention line)'
                      : 'Address 3'
                    : SHOW_ALT_ADDR3_LABEL
                    ? 'Address Continued (if needed)'
                    : 'Attention'
                }
                fieldId={`address3-${fieldId}`}
              >
                <TextInput
                  onChange={this.setFieldValue}
                  onBlur={this.handleFieldBlur}
                  autoComplete="address-level4"
                  name="ADDR3"
                  value={value.ADDR3}
                  disabled={disabled}
                  required={false}
                  width="100%"
                  validityClass={isValidClass}
                  isValid={isValid}
                  fieldId={`address3-${fieldId}`}
                  ariaLabel={`${label}: ${
                    isForeign
                      ? 'Address line 3'
                      : SHOW_ALT_ADDR3_LABEL
                      ? 'Address Continued (if needed)'
                      : 'Attention'
                  }`}
                />
              </DumbField>
            </div>
          </div>
        )}
        {showCityStateZip
          ? ((isForeign && showCityStateZipOnForeignAddress) || !isForeign) && (
              <div className="row">
                <div
                  className={
                    triColSizes.CITY
                      ? triColSizes.CITY
                      : isForeign
                      ? 'col-sm-5 col-md-4 col-lg-2'
                      : 'col-sm-5 col-md-4 col-lg-3'
                  }
                >
                  <DumbField
                    type="text"
                    required={required}
                    parentType="addressBlock"
                    label="City"
                    fieldId={`addr-city-${fieldId}`}
                  >
                    <TextInput
                      onChange={this.setFieldValue}
                      onBlur={this.handleFieldBlur}
                      autoComplete="address-level2"
                      name="CITY"
                      value={value.CITY}
                      disabled={disabled}
                      required={true}
                      width="100%"
                      validityClass={isValidClass}
                      isValid={isValid}
                      fieldId={`addr-city-${fieldId}`}
                      ariaLabel={`${label}: City`}
                    />
                  </DumbField>
                </div>
                <div
                  className={
                    triColSizes.STATE
                      ? triColSizes.STATE
                      : isForeign
                      ? 'col-sm-3 col-md-3 col-lg-3'
                      : 'col-sm-3 col-md-3 col-lg-2'
                  }
                >
                  {!isForeign ? (
                    <DumbField
                      type="text"
                      required={required}
                      parentType="addressBlock"
                      label="State"
                      fieldId={`addr-state-${fieldId}`}
                    >
                      <Select
                        onChange={this.setFieldValue}
                        onBlur={(e) => {
                          this.handleFieldBlur(e)
                          this.handleStateBlur()
                        }}
                        options={[
                          { value: '', label: '' },
                          ...(excludeCurrentState ? filteredStateOptions : stateOptions),
                        ]}
                        autoComplete="region"
                        name="STATE"
                        value={value.STATE}
                        required={true}
                        width="100%"
                        validityClass={isValidClass}
                        isValid={isValid}
                        disabled={disabled === true ? true : disableState}
                        fieldId={`addr-state-${fieldId}`}
                        className={classNames.STATE}
                        ariaLabel={`${label}: State`}
                      />
                    </DumbField>
                  ) : (
                    <DumbField
                      type="text"
                      required={required}
                      parentType="addressBlock"
                      label="State/Province/Territory"
                      fieldId={`addr-state-${fieldId}`}
                    >
                      <TextInput
                        onChange={this.setFieldValue}
                        onBlur={this.handleFieldBlur}
                        autoComplete="address-level2"
                        name="STATE"
                        value={value.STATE}
                        disabled={disabled}
                        required={true}
                        width="100%"
                        validityClass={isValidClass}
                        isValid={isValid}
                        fieldId={`addr-state-${fieldId}`}
                        ariaLabel={`${label}: State/Province/Territory`}
                      />
                    </DumbField>
                  )}
                </div>
                <div className={triColSizes.ZIP ? triColSizes.ZIP : 'col-sm-3 col-md-3 col-lg-2'}>
                  <DumbField
                    type="text"
                    required={required}
                    parentType="addressBlock"
                    label={isForeign ? 'ZIP/Postal code' : 'ZIP Code'}
                    fieldId={`addr-zip-${fieldId}`}
                  >
                    <TextInput
                      onChange={
                        isForeign
                          ? this.setFieldValue
                          : (value, e) => this.setFieldValue(MASK.zipCode(value), e)
                      }
                      onBlur={(e) => {
                        this.handleFieldBlur(e)
                        this.handleZipBlur()
                      }}
                      name="POSTAL_CODE"
                      value={value.POSTAL_CODE}
                      autoComplete="postal-code"
                      disabled={disabled}
                      required={true}
                      width="100%"
                      validityClass={isValidClass}
                      isValid={isValid}
                      fieldId={`addr-zip-${fieldId}`}
                      ariaLabel={`${label}: ZIP code`}
                    />
                  </DumbField>
                </div>
              </div>
            )
          : null}
        {showCounty ? (
          <div className="row">
            <div className="col-sm-7 col-md-6 col-lg-5">
              <DumbField
                type="text"
                required={required}
                parentType="addressBlock"
                label="County"
                fieldId={`addr-county-${fieldId}`}
              >
                <TextInput
                  onChange={this.setFieldValue}
                  onBlur={this.handleFieldBlur}
                  name="COUNTY"
                  value={value.COUNTY}
                  disabled={disabled}
                  required={true}
                  width="100%"
                  validityClass={isValidClass}
                  isValid={isValid}
                  fieldId={`addr-county-${fieldId}`}
                  ariaLabel={`${label}: County`}
                />
              </DumbField>
            </div>
          </div>
        ) : null}
        {showCountry ? (
          <div className="row">
            <div className="col-sm-7 col-md-6 col-lg-5">
              <DumbField
                type="text"
                required={required}
                parentType="addressBlock"
                label="Country"
                fieldId={`addr-country-${fieldId}`}
              >
                <Select
                  onChange={this.setFieldValue}
                  onBlur={this.handleFieldBlur}
                  options={getCountryOptions()}
                  name="COUNTRY"
                  autoComplete="country"
                  value={value.COUNTRY}
                  required={true}
                  width="100%"
                  validityClass={isValidClass}
                  isValid={isValid}
                  disabled={disabled === true ? true : disableCountry}
                  fieldId={`addr-country-${fieldId}`}
                  ariaLabel={`${label}: country`}
                />
              </DumbField>
            </div>
          </div>
        ) : null}
        {
          ShowAddressValidationBypass ? (
                <div className="row">
                  <div className="flex-row checkbox-padding top-box">
                    <Checkbox
                        fieldId={`${fieldId}-bypass`}
                        label={getBypassMessage}
                        name="MAIL_ADDR_BYPASS_YN"
                        onChange={this.setBypassChecked}
                        value={this.state.isBypassAcknowledged}
                        onBlur={this.handleFieldBlur}
                        disabled={disabled}
                    />
                  </div>
                </div>
            )
            : null}
      </div>
    )
  }
}

export default connect((state, props) => ({
  hasAddresses:
    (getFieldsByType(['addressBlock', 'registeredAgentSearch'], state.wizard.wizard.fields) || [])
      .reduce((ads, ad) => {
        if (ad.type === 'registeredAgentSearch') {
          return [
            ...ads,
            { ...ad, fieldId: ad.fieldId + '_PRIMARY', value: { ADDR1: ad.value.ADDR1 } },
            { ...ad, fieldId: ad.fieldId + '_MAIL', value: { ADDR1: ad.value.MAIL_ADDR.ADDR1 } },
          ]
        } else {
          return [...ads, ad]
        }
      }, [])
      .filter(
        (address) =>
          address.parent.type !== 'REPEATER' &&
          address.fieldId !== props.fieldId &&
          address.value.ADDR1 !== '' &&
          address.active
      )
      .filter((address) => getControlIsRenderable(address, state.wizard.wizard.fields)).length > 0,
}))(AddressBlock)



// WEBPACK FOOTER //
// ./src/components/Wizard2/fieldComponents/AddressBlock.js